import { t } from "i18next";

export const CONTACT = {
  CALL_COLLECT_NUMBER: "+1-905-532-2954",
  EMAIL: "casemanagement@allshores.com",
  TOLL_FREE_NUMBER: "1-800-720-7315",
  WITHIN_BERMUDA_NUMBER: "+441 298-0429",
};

export const BANNER_BODY = [
  "banner-body-description-first-paragraph",
  "banner-body-description-second-paragraph",
];

export const SPECIALIZED_CARE_OPTIONS = [
  {
    icon: "infinit",
    label: "medical-second-opinion",
    link: false,
    linkValue: "",
  },
  {
    icon: "spinal",
    label: "spinal-network",
    link: true,
    linkValue: "SPINAL",
  },
  {
    icon: "exchange",
    label: "transplants",
    link: false,
    linkValue: "",
  },
  {
    icon: "phone",
    label: "tele-follow-up",
    link: false,
    linkValue: "",
  },
  {
    icon: "plus-sign",
    label: "non-solid-organ-transplant-network",
    link: true,
    linkValue: "NON SOLID ORGAN TRANSPLANTS",
  },
  {
    icon: "female",
    label: "neonatal.and.high.risk.pregnancy",
    link: true,
    linkValue: "NEONATAL NETWORK AND HIGH RISK PREGNANCY",
  },
  {
    icon: "oncology",
    label: "oncology.network",
    link: true,
    linkValue: "ONCOLOGY",
  },
  {
    icon: "heartbeat",
    label: "cardiology.network",
    link: true,
    linkValue: "CARDIOLOGY",
  },
  {
    icon: "orthopedic",
    label: "orthopedic.network",
    link: true,
    linkValue: "ORTHOPEDICS",
  },
];

export const IMAGEPATH = "/o/provider-search-cx/images/";

export const GOOGLE_MAP_URL = "http://maps.google.com/maps";
